import { observer } from "mobx-react";
import React, { FC } from "react";
import {
  Location,
  Navigate,
  NavigateFunction,
  Params,
  Route,
  Routes,
} from "react-router-dom";
import CheckoutDetailPageMain from "./CheckoutDetailPageMain";
import CheckoutGrid from "./CheckoutGrid";
import { Loader, withRouter } from "@mindmemobile/mm-shared-global";
import {
  ItemsStore,
  PurchaseStore,
  RolesAndPermissionStore,
} from "../../../shared/store";
import { DashboardGrid } from "../../../shared/styles";
import { MerchantAccountStore } from "../../../modules/merchantAccounts";

interface IProps {
  navigate: NavigateFunction;
  params: Readonly<Params<string>>;
  location: Location;
  itemStore: ItemsStore;
  rolesAndPermissionStore: RolesAndPermissionStore;
  merchantAccountStore: MerchantAccountStore;
}

const purchaseStore = new PurchaseStore();

const CheckoutsMain: FC<IProps> = ({
  itemStore,
  rolesAndPermissionStore,
  merchantAccountStore,
}) => {
  if (!itemStore.countryStore.countryDataLoaded) {
    return <>{new Loader().loaderComponent}</>;
  }
  function routes() {
    return (
      <Routes>
        <Route
          path={`/`}
          element={
            <CheckoutGrid
              itemStore={itemStore}
              rolesAndPermissionStore={rolesAndPermissionStore}
              merchantAccountStore={merchantAccountStore}
            />
          }
        />
        <Route
          path={`/detail/:id/:name?`}
          element={
            <CheckoutDetailPageMain
              itemStore={itemStore}
              purchaseStore={purchaseStore}
              rolesAndPermissionStore={rolesAndPermissionStore}
              merchantAccountStore={merchantAccountStore}
            />
          }
        />{" "}
        <Route path="*" element={<Navigate to="/checkouts" />} />
      </Routes>
    );
  }

  return (
    <>
      <DashboardGrid>{routes()}</DashboardGrid>
    </>
  );
};

export default withRouter(observer(CheckoutsMain));
